<template>
<div class="chapter">
<div class="inner_page">
<div id="part2">
<h1><a id="page29"></a><a href="#/007toc#p02">PART 2<br/>Religion Is A Headache</a></h1>
<p class="center"><i>Many Christians still walk in Old Covenant bondage.<br/>Regarding the law as a Divine ordinance for our direction,<br/>they consider themselves prepared and fitted by conversion to<br/>take up the fulfillment of the law as a natural duty.</i></p>
<p class="center">Andrew Murray (1828-1917)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013part2.vue?487e144e